import WeeklyTimeSummary from "./WeeklyTimeSummary";

const WeeklyTimeSummaryPage = () => {
  return <WeeklyTimeSummary />;
};

export default WeeklyTimeSummaryPage;
